import { ShoppingBagOutlined } from "@mui/icons-material";
import { Box, Card, CardContent, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactComponent as OrderConfirmSvg } from "../../../../assets/svg/humcart_orderconfirm.svg";
import * as OrderReducer from "../../../../redux/orders/orders.reducers";
import { RootState } from "../../../../redux/store";
import { RevealFade } from "../../../../utils/Reveal";
import Button3D from "../../../../utils/common/3d-button/Button3D";
import LayoutHeading from "../../../layout/components/layout-heading/LayoutHeading";
import MainNavBar from "../../../layout/pages/navbar/MainNavBar";
import SpinnerUI from "../../../ui/components/spinner/SpinnerUI";

function OrderDetailsText(props: any) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={5} sm={4} sx={{ my: 1 }}>
        <Typography
          sx={{
            fontWeight: "500",
            fontFamily: "Ubuntu",
            width: "100%",
            fontSize: { xs: "13px", sm: "initial" },
            textWrap: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {props.primary}
        </Typography>
      </Grid>
      <Grid item xs={7} sm={8} sx={{ my: 1 }}>
        <Typography
          sx={{
            fontWeight: "bold",
            fontFamily: "Ubuntu",
            width: "100%",
            fontSize: { xs: "13px", sm: "initial" },
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          :{" "}
          {props.primary === "Total Amount"
            ? `₹${props.secondary}`
            : props.secondary}
        </Typography>
      </Grid>
    </Grid>
  );
}

const OrderDetails: React.FC = () => {
  const navigate = useNavigate();

  //Get Orders Data From Redux
  const orderReduxState: OrderReducer.InitialState = useSelector(
    (state: RootState) => {
      return state[OrderReducer.orderFeatureKey];
    }
  );

  const { loading, orderProduct } = orderReduxState;
  return (
    <>
      <Box>
        {loading && <SpinnerUI />}
        <MainNavBar />
        <LayoutHeading
          heading="Order Details"
          description="View comprehensive order information, including items, pricing, and delivery status."
        />
        <Grid container sx={{ px: { xs: 1, md: 9, lg: 10 }, gap: "10px" }}>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            sx={{ background: "#fff", borderRadius: "10px", p: 2 }}
          >
            <Box
              sx={{
                width: {
                  xs: "220px",
                  sm: "270px",
                  md: "300px",
                  lg: "400px",
                  xl: "100%",
                },
                maxWidth: "500px",
                px: 1,
                my: 2,
                p: 2,
                mx: "auto",
              }}
            >
              <RevealFade>
                <OrderConfirmSvg />
              </RevealFade>

              <RevealFade>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Nunito",
                    color: "#01d426",
                    textAlign: "center",
                    fontSize: {
                      xs: "16px",
                      sm: "20px",
                      md: "22px",
                      lg: "25px",
                    },
                    my: 1,
                  }}
                >
                  Order Placed Successfully!
                </Typography>
              </RevealFade>
            </Box>
          </Grid>
          <Grid
            component={Paper}
            sx={{ background: "#fff", borderRadius: "10px", p: 2 }}
            elevation={0}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <Card elevation={0} sx={{ background: "transparent" }}>
              <CardContent
                sx={{ my: 1, px: 2, py: 1, pb: 2, borderRadius: "10px" }}
              >
                {orderProduct && Object.keys(orderProduct).length > 0 && (
                  <>
                    <OrderDetailsText
                      primary={"Order ID"}
                      secondary={orderProduct._id.toUpperCase()}
                    />
                    <OrderDetailsText
                      primary={"Total Amount"}
                      secondary={orderProduct.total.toFixed(2)}
                    />
                    <OrderDetailsText
                      primary={"Order Status"}
                      secondary={orderProduct.orderStatus}
                    />
                    <OrderDetailsText
                      primary={"Payment Mode"}
                      secondary={orderProduct.paymentType}
                    />
                  </>
                )}
              </CardContent>
              <Box sx={{ width: "100%", py: 1, pl: 2 }}>
                <Button3D
                  onClick={() => {
                    navigate("/products/fashion");
                  }}
                  buttonText="Continue Shopping"
                  buttonIcon={<ShoppingBagOutlined sx={{ px: 1 }} />}
                />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default OrderDetails;
